import { linearAnimation } from './linear-animation';

function getAbsoluteOnPageCoords(elem) {
  var box = elem.getBoundingClientRect();
  return {
    top: box.top + pageYOffset,
    left: box.left + pageXOffset
  };
}

export var glowHoverEffect = function glowHoverEffect(el, _a) {
  var hoverBg = _a.hoverBg,
      lightColor = _a.lightColor,
      _b = _a.lightSize,
      lightSize = _b === void 0 ? 100 : _b,
      _c = _a.lightSizeEnterAnimationTime,
      lightSizeEnterAnimationTime = _c === void 0 ? 100 : _c,
      _d = _a.lightSizeLeaveAnimationTime,
      lightSizeLeaveAnimationTime = _d === void 0 ? 50 : _d,
      _e = _a.isElementMovable,
      isElementMovable = _e === void 0 ? false : _e,
      _f = _a.customStaticBg,
      customStaticBg = _f === void 0 ? null : _f;
  var elStyles = getComputedStyle(el);
  var resolvedHoverBg = hoverBg ? hoverBg : elStyles.backgroundColor;
  var box;

  if (!isElementMovable) {
    box = getAbsoluteOnPageCoords(el);
  }

  var currentLightSize = 0;
  var lightSizeEnterAnimationId = null;
  var lightSizeLeaveAnimationId = null;
  var gradientLastXPos = null;
  var gradientLastYPos = null;

  var updateGlowEffect = function updateGlowEffect() {
    // we dont use transparent color here because of https://youtrack.jetbrains.com/issue/WUI-843
    var gradient = "radial-gradient(circle at " + gradientLastXPos + "px " + gradientLastYPos + "px, " + lightColor + " 0%, " + resolvedHoverBg + " " + currentLightSize + "px) no-repeat"; // we duplicate resolvedHoverBg layer here because of transition "blinking" without it (for example, Button component)

    el.style.background = gradient + " border-box border-box " + resolvedHoverBg;
  };

  var onMouseEnter = function onMouseEnter() {
    box = getAbsoluteOnPageCoords(el);
    window.cancelAnimationFrame(lightSizeEnterAnimationId);
    window.cancelAnimationFrame(lightSizeLeaveAnimationId); // animate currentLightSize from 0 to lightSize

    linearAnimation({
      onProgress: function onProgress(progress) {
        currentLightSize = lightSize * progress;
        updateGlowEffect();
      },
      time: lightSizeEnterAnimationTime,
      initialProgress: currentLightSize / lightSize,
      onIdUpdate: function onIdUpdate(newId) {
        return lightSizeEnterAnimationId = newId;
      }
    });
  };

  var onMouseMove = function onMouseMove(e) {
    if (isElementMovable) {
      box = getAbsoluteOnPageCoords(el);
    }

    gradientLastXPos = e.pageX - box.left;
    gradientLastYPos = e.pageY - box.top;
    updateGlowEffect();
  };

  var onMouseLeave = function onMouseLeave() {
    window.cancelAnimationFrame(lightSizeEnterAnimationId);
    window.cancelAnimationFrame(lightSizeLeaveAnimationId); // animate currentLightSize from lightSize to 0

    linearAnimation({
      onProgress: function onProgress(progress) {
        currentLightSize = lightSize * (1 - progress);

        if (progress < 1) {
          updateGlowEffect();
        } else {
          el.style.background = customStaticBg ? customStaticBg : '';
        }
      },
      time: lightSizeLeaveAnimationTime,
      initialProgress: 1 - currentLightSize / lightSize,
      onIdUpdate: function onIdUpdate(newId) {
        return lightSizeLeaveAnimationId = newId;
      }
    });
  };

  el.addEventListener('mouseenter', onMouseEnter);
  el.addEventListener('mousemove', onMouseMove);
  el.addEventListener('mouseleave', onMouseLeave);
  return function () {
    window.cancelAnimationFrame(lightSizeEnterAnimationId);
    window.cancelAnimationFrame(lightSizeLeaveAnimationId);
    el.removeEventListener('mouseenter', onMouseEnter);
    el.removeEventListener('mousemove', onMouseMove);
    el.removeEventListener('mouseleave', onMouseLeave);
  };
};
//# sourceMappingURL=glow-hover-effect.js.map